<template>
  <add-banks :prev="prevRoute" />
</template>
<script>
import AddBanks from '@/components/bank-accounts/AddBanks'

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.name
    })
  },
  data() {
    return {
      prevRoute: null
    }
  },
  components: { AddBanks },
  mounted() {
    this.$mpTrack('Add Bank page mounted')
  }
}
</script>
